export default __webpack_public_path__ + "static/media/cuerpo-hombre-piel-clara.57a19045.png";